import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import FloatingCartButton from './components/FloatingCartButton';
import CartToast from './components/CartToast';
import { CartProvider } from './context/CartContext';

// Pages
import HomePage from './pages/HomePage';
import DogFoodPage from './pages/DogFoodPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CatFoodPage from './pages/CatFoodPage';
import DiversePage from './pages/DiversePage';
import JoseraPage from './pages/JoseraPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CartPage from './pages/CartPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen bg-[#F5F1E8] text-[#252927]">
          <Header />
          <main className="flex-1">
            <Routes>
              {/* Primary Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/hundefoder" element={<DogFoodPage />} />
              <Route path="/produkter/:slug" element={<ProductDetailPage />} />
              <Route path="/kat" element={<CatFoodPage />} />
              <Route path="/diverse" element={<DiversePage />} />
              <Route path="/forhandlere" element={<Navigate to="/kontakt" replace />} />
              <Route path="/forhandlere/" element={<Navigate to="/kontakt" replace />} />
              <Route path="/josera" element={<JoseraPage />} />
              <Route path="/om-kromix" element={<AboutPage />} />
              <Route path="/foelg-os" element={<Navigate to="/om-kromix" replace />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/kurv" element={<CartPage />} />
              <Route path="/bestil" element={<Navigate to="/kurv" replace />} />

              {/* Legacy URL Redirects from Scrape to ensure 100% backwards compatibility */}
            <Route path="/information" element={<Navigate to="/om-kromix" replace />} />
            <Route path="/information/" element={<Navigate to="/om-kromix" replace />} />
            <Route path="/nyheder" element={<Navigate to="/om-kromix" replace />} />
            <Route path="/nyheder/" element={<Navigate to="/om-kromix" replace />} />
            <Route path="/hund" element={<Navigate to="/hundefoder" replace />} />
            <Route path="/hund/" element={<Navigate to="/hundefoder" replace />} />
            <Route path="/hund/:slug" element={<LegacyDogRedirect />} />
            <Route path="/diverse/:slug" element={<LegacyDiverseRedirect />} />
            <Route path="/kat/:slug" element={<CatFoodPage />} />

            {/* Status pages */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <CartDrawer />
        <FloatingCartButton />
        <CartToast />
      </div>
    </CartProvider>
  </HelmetProvider>
);
}

// Redirect helpers for scrape URL structures
import { useParams } from 'react-router-dom';

function LegacyDogRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/produkter/${slug}`} replace />;
}

function LegacyDiverseRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/produkter/${slug}`} replace />;
}
